
  
  document.addEventListener('DOMContentLoaded', function() {
  var loadSvgDetails = [
    {
      'selector': ['#shopify-section-template--21178464502088__f567158a-f3cd-42bb-a154-238ff40b79d0'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/ulrichvalleelionwhite.svg?v=1713625985',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '15rem',
        'width': '17%',
        'z-index': '-1',
        'opacity': '0.1',
        'class': 'svg_bg_1',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '30%',
            'top': '10rem'
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
    		'width': '17%'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
    		'width': '17%'
          },
          '(min-width: 1440px) and (max-width: 1920px)': {
    		'width': '17%'
          },
          '(min-width: 1921px)': {
    		'width': '15%'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__f567158a-f3cd-42bb-a154-238ff40b79d0'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/ulrichvalleelionwhite.svg?v=1713625985',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '9rem',
        'z-index': '0',
        'width': '37%',
        'opacity': '0.2',
        'class': 'svg_bg_2',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__1686159157bc3d096d #faq_body_1324_top_atc_1_1'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/renouveau.svg?v=1713633168',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '-55px',
        'width': '50%',
        'margin' : '0 auto',
        'z-index': '-1',
        'opacity': '0.5',
        'class': 'svg_bg_3',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '50%',
			'right': '0',
            'top': '-30px' 
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
    		'width': '50%',
			'right': '0',
            'top': '-45px'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
    		'width': '50%',
			'right': '0',
            'top': '-50px'
          },
          '(min-width: 1440px)': {
    		'width': '50%',
			'right': '0',
            'top': '-55px'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__1686159157bc3d096d'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/renouveau.svg?v=1713633168',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '52px',
        'z-index': '0',
        'width': '100%',
        'opacity': '0.7',
        'class': 'svg_bg_4',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__1686159157bc3d096d #faq_body_1324_top_atc_2_1'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/fastlane.svg?v=1713703981',
      'css': {
        'position': 'absolute',
        'left': '0',
        'right': '0',
        'top': '68px',
        'width': '70%',
        'margin' : '0 auto',
        'z-index': '-1',
        'opacity': '0.5',
        'class': 'svg_bg_5',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '45%',
            'top': '65px' 
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
            'top': '75px'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
            'top': '70px'
          },
          '(min-width: 1440px)': {
            'top': '68px'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__1686159157bc3d096d #faq_body_1324_top_atc_2_1'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/fastlane.svg?v=1713703981',
      'css': {
        'position': 'absolute',
        'left': '0',
        'right': '0',        
        'margin' : '0 auto',
        'top': '50px',
        'z-index': '0',
        'width': '70%',
        'opacity': '0.7',
        'class': 'svg_bg_6',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__1686159157bc3d096d #faq_body_1324_top_atc_2_2'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/vision.svg?v=1713703981',
      'css': {
        'position': 'absolute',
        'left': '0',
        'right': '0',
        'top': '68px',
        'width': '47%',
        'margin' : '0 auto',
        'z-index': '-1',
        'opacity': '0.5',
        'class': 'svg_bg_7',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '30%',
            'top': '65px' 
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
            'top': '75px'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
            'top': '70px'
          },
          '(min-width: 1440px)': {
            'top': '68px'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__1686159157bc3d096d #faq_body_1324_top_atc_2_2'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/vision.svg?v=1713703981',
      'css': {
        'position': 'absolute',
        'left': '0',
        'right': '0',        
        'margin' : '0 auto',
        'top': '50px',
        'z-index': '0',
        'width': '45%',
        'opacity': '0.7',
        'class': 'svg_bg_8',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__1686159157bc3d096d #faq_body_1324_top_atc_2_3'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/kehio.svg?v=1713703981',
      'css': {
        'position': 'absolute',
        'left': '0',
        'right': '0',
        'top': '68px',
        'width': '42%',
        'margin' : '0 auto',
        'z-index': '-1',
        'opacity': '0.5',
        'class': 'svg_bg_9',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '27%',
            'top': '65px' 
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
            'top': '75px'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
            'top': '70px'
          },
          '(min-width: 1440px)': {
            'top': '68px'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__1686159157bc3d096d #faq_body_1324_top_atc_2_3'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/kehio.svg?v=1713703981',
      'css': {
        'position': 'absolute',
        'left': '0',
        'right': '0',        
        'margin' : '0 auto',
        'top': '50px',
        'z-index': '0',
        'width': '40%',
        'opacity': '0.7',
        'class': 'svg_bg_10',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__16997006844dbacb6b'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/ulrichvalleelionwhite.svg?v=1713625985',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '15rem',
        'width': '17%',
        'z-index': '-1',
        'opacity': '0.1',
        'class': 'svg_bg_11',
        'display': 'block',
        'mediaQueries': {
          '(max-width: 767px)': {
    		'display': 'none'
          },
          '(min-width: 768px) and (max-width: 1024px)': {
    		'width': '30%',
            'top': '10rem'
          },
          '(min-width: 1025px) and (max-width: 1280px)': {
    		'width': '17%'
          },
          '(min-width: 1281px) and (max-width: 1439px)': {
    		'width': '17%'
          },
          '(min-width: 1440px) and (max-width: 1920px)': {
    		'width': '17%'
          },
          '(min-width: 1921px)': {
    		'width': '15%'
          }
        }
      }
    },
    {
      'selector': ['#shopify-section-template--21178464502088__16997006844dbacb6b'],
      'svg_url':'https://cdn.shopify.com/s/files/1/2407/5779/files/ulrichvalleelionwhite.svg?v=1713625985',
      'css': {
        'position': 'absolute',
        'left': '0',
        'top': '9rem',
        'z-index': '0',
        'width': '37%',
        'opacity': '0.2',
        'class': 'svg_bg_12',
        'display': 'none',
        'mediaQueries': {
          '(max-width: 768px)': {
                'display': 'block',
            },
            '(min-width: 768px)': {
                'display': 'none',
            }
          }
      }
    },
    
  ];

  var resizeTimeout;//

  var resizeTimeout;

  for (var i = 0; i < loadSvgDetails.length; i++) {
    
    var selectors = loadSvgDetails[i].selector;
    var svgType = loadSvgDetails[i].svg;
    var cssProperties = loadSvgDetails[i].css;
    var mediaQueries = cssProperties.mediaQueries;
    var container = document.createElement('div');
    if(typeof loadSvgDetails[i].svg_url !== "undefined" && loadSvgDetails[i].svg_url != ''){
      var innerHtmlToAdd = '<img alt src="'+loadSvgDetails[i].svg_url+'" >';
    }else{
      var innerHtmlToAdd = svgData[svgType]
    }
    for (var s = 0; s < selectors.length; s++) {
      var selector = selectors[s];
      var element = document.querySelector(selector);
      if (element) {
        
        container.innerHTML = innerHtmlToAdd;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('dfredfd_container');
        container.classList.add(cssProperties.class);
        container.classList.add(cssProperties.class+'_'+s);
        container.classList.add('svg_bg_wrap');
        container.classList.add('fade_up_animate');
        //container.setAttribute('data-aos','fade-up');
        //container.setAttribute('data-aos-once','false');
       // if (window.scrollY === 0) {
         // container.setAttribute('data-aos-offset', '100');
       //   }
  
        applyCSSProperties(container, cssProperties);
  
        for (var mqQuery in mediaQueries) {
          var mqCSSProperties = mediaQueries[mqQuery];
  
          var mediaQueryList = window.matchMedia(mqQuery);
          mediaQueryList.addListener(createMediaQueryListener(container, mqCSSProperties));
  
          if (mediaQueryList.matches) {
            applyCSSProperties(container, mqCSSProperties);
          }
        }
        handleScroll();
        //Initialize AOS with desired options
        // AOS.init({
        //   duration: 1000,
        //   delay: 200,
        //   easing: 'ease-in-out',
        //  // data-aos-once
        //   // Add more options as needed
        // });
      } else {
        //console.log('Element with selector:', selector, ' not found.');
      }
    }
  }

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      for (var i = 0; i < loadSvgDetails.length; i++) {
        var selectors = loadSvgDetails[i].selector;
        
        var mediaQueries = loadSvgDetails[i].css.mediaQueries;
        for (var s = 0; s < selectors.length; s++) {
          var selector = selectors[s];
          
          var element = document.querySelector(selector);
  
          if (element) {
          //var container = element.querySelector('> .' + loadSvgDetails[i].css.class);
         // var childElements = Array.from(element.children);
          var container = document.querySelector(selector +' > .'+loadSvgDetails[i].css.class);

          for (var mqQuery in mediaQueries) {
            var mqCSSProperties = mediaQueries[mqQuery];
            var mediaQueryList = window.matchMedia(mqQuery);

            if (mediaQueryList.matches) {
              applyCSSProperties(container, mqCSSProperties);
            }
          }
        }
        }
      }
    }, 200); // Adjust the timeout duration as needed
  });
    function isInViewport(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        
        // Check if the top of the element has started entering the viewport from the bottom
        return rect.top >= 0 && rect.top < windowHeight;
    }
    
    function handleScroll() {
        const fadeUpElements = document.querySelectorAll('.fade_up_animate:not(.animated)');  // Select elements that are not yet visible
        //console.log(fadeUpElements.length)
        fadeUpElements.forEach(element => {
            if (isInViewport(element)) {
                element.classList.add('animated');
            }
        });
    }
    
    window.addEventListener('scroll', handleScroll);

  function createMediaQueryListener(element, properties) {
    return function(mql) {
      if (mql.matches) {
        applyCSSProperties(element, properties);
      }
    };
  }

  function applyCSSProperties(element, properties) {
    for (var property in properties) {
      if (property === 'class') {
        element.classList.add(properties[property]);
      } else {
        element.style[property] = properties[property];
      }
    }
  }
  var buttons = document.querySelectorAll('a[href="#discuteravecunexpert"]');

    // Iterate over the selected elements and bind the click event handler
    buttons.forEach(function(button) {
      button.addEventListener('click', function() {
        // Code to execute when the button is clicked
        event.preventDefault();
        toggleDemoRequestForm();
        // Additional code...
      });
    });
    var imageSVG = '<?xml version="1.0" encoding="UTF-8"?><svg id="circlekehiobg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 225"><defs><style>.circlekehiobg-1{fill:#fffcf4;}.circlekehiobg-1,.circlekehiobg-2,.circlekehiobg-3{stroke-width:0px;}.circlekehiobg-3{fill:#ff592b;}</style></defs><circle class="circlekehiobg-1" cx="112.5" cy="112.5" r="105"/><path class="circlekehiobg-2" d="m112.5,0C50.37,0,0,50.37,0,112.5s50.37,112.5,112.5,112.5,112.5-50.37,112.5-112.5S174.63,0,112.5,0Zm94.08,77.42l-13.73,10.12.02.07,17.04.55,2.15,6.89-26.92-1.57-2.04-6.57,21.27-16.57,2.2,7.08h0Zm-15.11-26.7l-7.2,14.45.05.06,11.55-8.6,3.99,5.37-20.24,15.07-4.77-6.4,8.32-16.71-.05-.06-13.35,9.94-3.99-5.37,20.24-15.07s5.45,7.32,5.45,7.32Zm-23.71-22.3c6.54,4.3,8.17,11.84,4,18.19-4.18,6.35-11.75,7.83-18.28,3.52s-8.17-11.84-4-18.19c4.18-6.35,11.75-7.83,18.28-3.52Zm-43.37-3.41c1.94-7.35,8.6-11.17,16.43-9.11,3.38.89,5.17,1.87,6.81,3.53l-1.91,7.24-.29-.08c-.94-2.25-2.98-3.89-5.85-4.65-4.04-1.07-7.38.85-8.43,4.85s.9,7.31,4.94,8.38c2.87.76,5.45.34,7.38-1.16l.29.08-1.91,7.24c-2.25.63-4.28.6-7.66-.29-7.83-2.06-11.74-8.68-9.8-16.02h0Zm-63.13,13.85l2.44-1.64,1.14,2.67,1.32-2.56,2.3,1.77-2.22,1.93,2.9.48-1.02,2.74-2.48-1.5.45,2.86-2.92-.09.65-2.87-2.62,1.33-.77-2.8,2.86-.26-2.05-2.06h.02Zm-22.95,5.68c5.29-5.77,12.99-6.19,18.6-1.05s5.86,12.85.57,18.62-12.99,6.19-18.6,1.05c-5.6-5.14-5.86-12.84-.57-18.62Zm-24.11,47.81l9.21,2.32,2.19-8.7-9.21-2.32,1.69-6.71,24.47,6.15-1.69,6.71-9.29-2.33-2.19,8.7,9.29,2.33-1.69,6.71-24.47-6.15,1.69-6.71Zm-2.37,17l6.14-.41.82,12.21,3.68-.25-.63-9.48,5.61-.38.63,9.48,3.6-.24-.82-12.21,6.14-.41,1.28,19.11-25.18,1.68-1.28-19.11h0Zm33.94,52.82l-2.87-.64,1.35,2.61-2.79.78-.27-2.86-2.05,2.06-1.65-2.43,2.67-1.15-2.56-1.3,1.75-2.31,1.94,2.21.46-2.91,2.74,1.01-1.49,2.48,2.86-.47-.07,2.92h-.02Zm-22.69-3.1l-2.53-6.44,9.09-3.57-.03-.07-11.83-3.4-3.15-8.03,15.2,4.81,8.15-14.38,3.29,8.38-6.35,10.54.03.07,9.09-3.57,2.53,6.44-23.49,9.22h0Zm21.65-78.92l-22.24-11.93,3.27-6.1,22.24,11.93-3.27,6.1Zm64.08,116.48l-.3-.05c-2.02-2.28-4.97-3.86-8.2-4.37-2.59-.41-3.89.04-4.11,1.39-.17,1.09.68,1.76,3.83,2.53,6.26,1.53,8.46,4.15,7.7,8.99-.83,5.26-5.14,7.69-11.78,6.64-3.04-.48-6.09-1.65-7.43-2.87l1.1-6.98.3.05c1.38,1.95,4,3.4,7.08,3.89,2.33.37,3.67-.11,3.88-1.43.17-1.09-.65-1.72-3.76-2.52-6.29-1.61-8.49-4.23-7.7-9.22.82-5.18,4.95-7.49,11.56-6.44,4.2.66,7.14,1.78,8.93,3.41l-1.1,6.98h0Zm-58.81-84.13c0-34.52,27.98-62.5,62.5-62.5s62.5,27.98,62.5,62.5-27.98,62.5-62.5,62.5-62.5-27.98-62.5-62.5Zm80.33,98.67l-9.41-13.12h-.08l2.2,14.24-6.61,1.02-3.85-24.93,7.89-1.22,10.88,15.16h.08l-2.54-16.46,6.61-1.02,3.85,24.93-9.01,1.39h-.01Zm30.81-10.59c-6.85,3.79-14.28,1.73-17.96-4.92s-1.47-14.04,5.38-17.82,14.28-1.73,17.96,4.92,1.47,14.04-5.38,17.82Zm17.5-12.7l-17.29-18.38,5.04-4.74,17.28,18.38-5.04,4.74h.01Zm16.24-17.61c-1.75,2.53-4.13,4.77-5.81,5.46l-5.82-4.02.17-.25c2.36-.4,4.8-2.13,6.57-4.7,1.34-1.94,1.49-3.36.4-4.12-.91-.63-1.83-.16-3.9,2.3-4.17,4.97-7.49,5.82-11.65,2.95-4.31-2.98-4.6-7.71-.8-13.21,2.42-3.5,4.7-5.67,6.94-6.57l5.82,4.02-.17.25c-2.93.84-5.63,2.8-7.49,5.49-1.49,2.16-1.65,3.52-.52,4.3.91.63,1.88.15,3.94-2.36,4.09-4.98,7.4-5.83,11.44-3.05,4.38,3.02,4.71,7.96.88,13.5h0Zm12.8-26.3c-1.96,6.19-5.73,8.51-11.09,6.81-3.77-1.2-5.76-3.58-5.91-7.02l-10.26,2.69,2.45-7.72,9.2-1.87.77-2.43-7.82-2.48,2.09-6.59,24.05,7.63-3.48,10.98h0Zm-1.28-20.87l.2-12.23-3.69-.06-.15,9.5-5.62-.09.15-9.5-3.61-.06-.2,12.23-6.16-.1.31-19.15,25.23.41-.31,19.15-6.16-.1h.01Z"/><path class="circlekehiobg-2" d="m43.61,57.99c3,2.75,6.76,2.75,9.33-.06,2.57-2.8,2.24-6.55-.75-9.3-3-2.75-6.76-2.75-9.33.06-2.57,2.8-2.24,6.55.75,9.3Z"/><path class="circlekehiobg-2" d="m151.55,183.22c-3.32,1.84-4.21,5.5-2.24,9.06s5.54,4.75,8.86,2.91c3.33-1.84,4.21-5.5,2.24-9.06s-5.54-4.75-8.86-2.91Z"/><path class="circlekehiobg-2" d="m156.86,44.98c3.17,2.09,6.83,1.17,9.06-2.22,2.24-3.4,1.63-7.11-1.54-9.2s-6.83-1.17-9.06,2.22c-2.23,3.4-1.63,7.11,1.54,9.2Z"/><path class="circlekehiobg-2" d="m198.72,144.12c1.56.49,2.53-.19,3.2-2.29l1.3-4.09-4.49-1.42-1.3,4.09c-.67,2.1-.27,3.23,1.29,3.72h0Z"/><path class="circlekehiobg-3" d="m112.5,50c-34.52,0-62.5,27.98-62.5,62.5s27.98,62.5,62.5,62.5,62.5-27.98,62.5-62.5-27.98-62.5-62.5-62.5Zm8.28,99.9l-13.34-14.72,13.38-14.33,26.48,29.05h-26.53,0Zm-37.65,0v-68h19.58l-.1,22.95,21.97-22.95h23.55s-65,68-65,68Z"/></svg>';
    var imageSelector = [
      {'selector':'#faq_body_617_info_2_2_1 > div','type':'left_svg'},
      {'selector':'#faq_body_598_info_2_2_1 > div','type':'left_svg'},
      {'selector':'#faq_body_602_info_4_2_1 > div','type':'left_svg'},
      {'selector':'#faq_body_456_info_4_1_2 > div','type':'right_svg'},
      {'selector':'#faq_body_456_info_4_1_2 > div','type':'right_svg'},
      {'selector':'#faq_body_459_info_7_1_1 > div','type':'right_svg'},
      {'selector':'#faq_body_263_info_6_1_2 > div','type':'right_svg'}
    ];
    
    for (var s = 0; s < imageSelector.length; s++) {
      var selectorImg = imageSelector[s];
     // console.log('selector',selectorImg);
      var element = document.querySelector(selectorImg.selector);
      if (element) {
        var container = document.createElement('div');
        container.innerHTML = imageSVG;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('image_svg_contain');
        container.classList.add('image_svg_wrap');
        container.classList.add(imageSelector[s].type);
      }
    }
     var imageSVG = '<?xml version="1.0" encoding="UTF-8"?><svg id="circlekehiobgdark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 225"><defs><style>.circlekehiobgdark-1{fill:#fffcf4;}.circlekehiobgdark-1,.circlekehiobgdark-2,.circlekehiobgdark-3{stroke-width:0px;}.circlekehiobgdark-2{fill:#ff592b;}.circlekehiobgdark-3{fill:#050b1d;}</style></defs><circle class="circlekehiobgdark-3" cx="112.5" cy="112.5" r="105"/><path class="circlekehiobgdark-1" d="m112.5,0C50.37,0,0,50.37,0,112.5s50.37,112.5,112.5,112.5,112.5-50.37,112.5-112.5S174.63,0,112.5,0Zm94.08,77.42l-13.73,10.12.02.07,17.04.55,2.15,6.89-26.92-1.57-2.04-6.57,21.27-16.57,2.2,7.08h0Zm-15.11-26.7l-7.2,14.45.05.06,11.55-8.6,3.99,5.37-20.24,15.07-4.77-6.4,8.32-16.71-.05-.06-13.35,9.94-3.99-5.37,20.24-15.07s5.45,7.32,5.45,7.32Zm-23.71-22.3c6.54,4.3,8.17,11.84,4,18.19-4.18,6.35-11.75,7.83-18.28,3.52s-8.17-11.84-4-18.19c4.18-6.35,11.75-7.83,18.28-3.52Zm-43.37-3.41c1.94-7.35,8.6-11.17,16.43-9.11,3.38.89,5.17,1.87,6.81,3.53l-1.91,7.24-.29-.08c-.94-2.25-2.98-3.89-5.85-4.65-4.04-1.07-7.38.85-8.43,4.85s.9,7.31,4.94,8.38c2.87.76,5.45.34,7.38-1.16l.29.08-1.91,7.24c-2.25.63-4.28.6-7.66-.29-7.83-2.06-11.74-8.68-9.8-16.02h0Zm-63.13,13.85l2.44-1.64,1.14,2.67,1.32-2.56,2.3,1.77-2.22,1.93,2.9.48-1.02,2.74-2.48-1.5.45,2.86-2.92-.09.65-2.87-2.62,1.33-.77-2.8,2.86-.26-2.05-2.06h.02Zm-22.95,5.68c5.29-5.77,12.99-6.19,18.6-1.05s5.86,12.85.57,18.62-12.99,6.19-18.6,1.05c-5.6-5.14-5.86-12.84-.57-18.62Zm-24.11,47.81l9.21,2.32,2.19-8.7-9.21-2.32,1.69-6.71,24.47,6.15-1.69,6.71-9.29-2.33-2.19,8.7,9.29,2.33-1.69,6.71-24.47-6.15,1.69-6.71Zm-2.37,17l6.14-.41.82,12.21,3.68-.25-.63-9.48,5.61-.38.63,9.48,3.6-.24-.82-12.21,6.14-.41,1.28,19.11-25.18,1.68-1.28-19.11h0Zm33.94,52.82l-2.87-.64,1.35,2.61-2.79.78-.27-2.86-2.05,2.06-1.65-2.43,2.67-1.15-2.56-1.3,1.75-2.31,1.94,2.21.46-2.91,2.74,1.01-1.49,2.48,2.86-.47-.07,2.92h-.02Zm-22.69-3.1l-2.53-6.44,9.09-3.57-.03-.07-11.83-3.4-3.15-8.03,15.2,4.81,8.15-14.38,3.29,8.38-6.35,10.54.03.07,9.09-3.57,2.53,6.44-23.49,9.22h0Zm21.65-78.92l-22.24-11.93,3.27-6.1,22.24,11.93-3.27,6.1Zm64.08,116.48l-.3-.05c-2.02-2.28-4.97-3.86-8.2-4.37-2.59-.41-3.89.04-4.11,1.39-.17,1.09.68,1.76,3.83,2.53,6.26,1.53,8.46,4.15,7.7,8.99-.83,5.26-5.14,7.69-11.78,6.64-3.04-.48-6.09-1.65-7.43-2.87l1.1-6.98.3.05c1.38,1.95,4,3.4,7.08,3.89,2.33.37,3.67-.11,3.88-1.43.17-1.09-.65-1.72-3.76-2.52-6.29-1.61-8.49-4.23-7.7-9.22.82-5.18,4.95-7.49,11.56-6.44,4.2.66,7.14,1.78,8.93,3.41l-1.1,6.98h0Zm-58.81-84.13c0-34.52,27.98-62.5,62.5-62.5s62.5,27.98,62.5,62.5-27.98,62.5-62.5,62.5-62.5-27.98-62.5-62.5Zm80.33,98.67l-9.41-13.12h-.08l2.2,14.24-6.61,1.02-3.85-24.93,7.89-1.22,10.88,15.16h.08l-2.54-16.46,6.61-1.02,3.85,24.93-9.01,1.39h-.01Zm30.81-10.59c-6.85,3.79-14.28,1.73-17.96-4.92s-1.47-14.04,5.38-17.82,14.28-1.73,17.96,4.92,1.47,14.04-5.38,17.82Zm17.5-12.7l-17.29-18.38,5.04-4.74,17.28,18.38-5.04,4.74h.01Zm16.24-17.61c-1.75,2.53-4.13,4.77-5.81,5.46l-5.82-4.02.17-.25c2.36-.4,4.8-2.13,6.57-4.7,1.34-1.94,1.49-3.36.4-4.12-.91-.63-1.83-.16-3.9,2.3-4.17,4.97-7.49,5.82-11.65,2.95-4.31-2.98-4.6-7.71-.8-13.21,2.42-3.5,4.7-5.67,6.94-6.57l5.82,4.02-.17.25c-2.93.84-5.63,2.8-7.49,5.49-1.49,2.16-1.65,3.52-.52,4.3.91.63,1.88.15,3.94-2.36,4.09-4.98,7.4-5.83,11.44-3.05,4.38,3.02,4.71,7.96.88,13.5h0Zm12.8-26.3c-1.96,6.19-5.73,8.51-11.09,6.81-3.77-1.2-5.76-3.58-5.91-7.02l-10.26,2.69,2.45-7.72,9.2-1.87.77-2.43-7.82-2.48,2.09-6.59,24.05,7.63-3.48,10.98h0Zm-1.28-20.87l.2-12.23-3.69-.06-.15,9.5-5.62-.09.15-9.5-3.61-.06-.2,12.23-6.16-.1.31-19.15,25.23.41-.31,19.15-6.16-.1h.01Z"/><path class="circlekehiobgdark-1" d="m43.61,57.99c3,2.75,6.76,2.75,9.33-.06,2.57-2.8,2.24-6.55-.75-9.3-3-2.75-6.76-2.75-9.33.06-2.57,2.8-2.24,6.55.75,9.3Z"/><path class="circlekehiobgdark-1" d="m151.55,183.22c-3.32,1.84-4.21,5.5-2.24,9.06s5.54,4.75,8.86,2.91c3.33-1.84,4.21-5.5,2.24-9.06s-5.54-4.75-8.86-2.91Z"/><path class="circlekehiobgdark-1" d="m156.86,44.98c3.17,2.09,6.83,1.17,9.06-2.22,2.24-3.4,1.63-7.11-1.54-9.2s-6.83-1.17-9.06,2.22c-2.23,3.4-1.63,7.11,1.54,9.2Z"/><path class="circlekehiobgdark-1" d="m198.72,144.12c1.56.49,2.53-.19,3.2-2.29l1.3-4.09-4.49-1.42-1.3,4.09c-.67,2.1-.27,3.23,1.29,3.72h0Z"/><path class="circlekehiobgdark-2" d="m112.5,50c-34.52,0-62.5,27.98-62.5,62.5s27.98,62.5,62.5,62.5,62.5-27.98,62.5-62.5-27.98-62.5-62.5-62.5Zm8.28,99.9l-13.34-14.72,13.38-14.33,26.48,29.05h-26.53,0Zm-37.65,0v-68h19.58l-.1,22.95,21.97-22.95h23.55s-65,68-65,68Z"/></svg>';
    var imageSelector = [
      {'selector':'#faq_body_604_info_6_2_1 > div','type':'left_svg'}
    ];
    
    for (var s = 0; s < imageSelector.length; s++) {
      var selectorImg = imageSelector[s];
     // console.log('selector',selectorImg);
      var element = document.querySelector(selectorImg.selector);
      if (element) {
        var container = document.createElement('div');
        container.innerHTML = imageSVG;
        var svgElement = container.firstChild;
  
        element.appendChild(container);
        element.classList.add('image_svg_contain');
        container.classList.add('image_svg_wrap');
        container.classList.add(imageSelector[s].type);
      }
    }
});
